// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import router from '@app/router'; // default export is the router OBJECT
import AppThemeProvider from './app/providers/ThemeProvider';
import SnackbarProvider from './app/providers/SnackbarProvider';
// Supports weights 100-900
import "@fontsource/inter/latin.css";


import 'leaflet/dist/leaflet.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppThemeProvider>
      <SnackbarProvider>
        <RouterProvider router={router} />
      </SnackbarProvider>
    </AppThemeProvider>
  </React.StrictMode>
);

